<ng-template #historyButtons>
      <button type="button" class="ws-card-btn" aria-label="Back" title="Back"
              [disabled]="!canBack" (click)="backRequested.emit()">
        <br-icon>arrow_back</br-icon>
      </button>
      <button type="button" class="ws-card-btn" aria-label="Forward" title="Forward"
              [disabled]="!canForward" (click)="forwardRequested.emit()">
        <br-icon>arrow_forward</br-icon>
      </button>
</ng-template>
<nav *ngIf="!open && (canBack || canForward)" class="ws-card-controls workspace-history" aria-label="Workspace history">
  <ng-container *ngTemplateOutlet="historyButtons"></ng-container>
</nav>
<div class="ws-host" [class.hidden]="!open" [class.ws-host--dock-right]="dockedRight">
  <div class="ws-backdrop" *ngIf="!dockedRight" (click)="closeRequested.emit()"></div>

  <main class="ws-card"
        [class.ws-card--max]="maximized"
        [class.ws-card--dock-right]="dockedRight"
        [appResizeX]="dockedRight ? '--ws-docked-w' : ''"
        [resizeMin]="8"
        [resizeMax]="0"
        [resizeViewportInset]="50"
        resizeEdge="left">
    <div class="ws-card-controls">
      <ng-container *ngTemplateOutlet="historyButtons"></ng-container>
      <button type="button" class="ws-card-btn"
              [attr.aria-label]="dockedRight ? 'Restore window' : 'Dock workspace right'"
              [title]="dockedRight ? 'Restore window' : 'Dock right'"
              (click)="dockRightRequested.emit()">
        <br-icon class="ws-card-mode-icon" [svgIcon]="dockedRight ? 'br:window' : 'br:dock-right'"></br-icon>
      </button>
      <button type="button" class="ws-card-btn"
              [attr.aria-label]="maximized ? 'Restore' : 'Maximize'"
              [title]="maximized ? 'Restore' : 'Maximize'"
              (click)="maximizeRequested.emit()">
        <br-icon class="ws-card-mode-icon" [svgIcon]="maximized ? 'br:window' : 'br:maximize'"></br-icon>
      </button>
      <button type="button" class="ws-card-btn" aria-label="Close" title="Close"
              (click)="closeRequested.emit()">
        <br-icon>close</br-icon>
      </button>
    </div>

    <div #body class="ws-card-body br-compact-page"
         (wheel)="cancelScrollRestore()" (pointerdown)="cancelScrollRestore()" (keydown)="cancelScrollRestore()"
         [class.ws-card-body--with-chat]="!dockedRight">
      <app-workspace-breadcrumbs [breadcrumbs]="breadcrumbs"></app-workspace-breadcrumbs>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
